import React, { createContext, useContext, useState } from "react";

type NavItemContextType = {
  focusedNavItem: string;
  setFocusedNavItem: (title: string) => void;
  clickedNavItem: string | null;
  setClickedNavItem: (title: string) => void;
};

export const NavItemContext = createContext<NavItemContextType>(null!);

export const NavItemProvider = ({ children }) => {
  //   const [items, setItems] = useState<NavSquare[]>([]);
  const [focusedNavItem, setFocusedNavItem] = useState<string>("");
  const [clickedNavItem, setClickedNavItem] = useState<string | null>(null);

  const setClickedItem = (newItem: string) => {
    setClickedNavItem(newItem);
    setFocusedNavItem(newItem);
    setTimeout(() => {
      setClickedNavItem(null);
    }, 500);
  };

  return (
    <NavItemContext.Provider
      value={{
        // items,
        // setItems,
        focusedNavItem,
        setFocusedNavItem,
        clickedNavItem,
        setClickedNavItem: setClickedItem,
      }}
    >
      {children}
    </NavItemContext.Provider>
  );
};

export const useNavItemProvider = () => useContext(NavItemContext);
